const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

// TODO: Why doesn't the API throw an error when the track is updated with missing required fields?

/**
 * Edit Tracks Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Tracks} Tracks injected to gain access to the Tracks resource
 */
app.controller('editTrack', ['Application', 'Authorization', 'Analyze', 'Tracks', 'AdminContent', 'Viewables', 'Assessments', 'AccessHelper', 'SurveyHelper', '$q', '$scope', '$location', '$translate', function(Application, Authorization, Analyze, Tracks, AdminContent, Viewables, Assessments, AccessHelper, SurveyHelper, $q, $scope, $location, $translate) {
    var self = this;
    var routeParameters = Application.navigation.getRouteParameters();
    self.enableAi = !!Application.features.flags().enable_generative_ai;
    self.newTrack = routeParameters.id === 'new' || !routeParameters.id;
    self.features = Application.features.flags();
    self.allowance = {
      create_track: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'tracks_create']], ['admin', 'creator', 'collaborator']),
      edit_track: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'tracks_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
      add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!self.newTrack && !self.allowance.edit_track) || (self.newTrack && !self.allowance.create_track)) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.returnState = Application.messaging.clearMessages('trackstate');
    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.editSaved = true;
    self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
    self.denied = false;
    self.archiveInfo = {};

    self.locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.editSaved) {
        // Allow the route change to progress
        self.locationChange();
        Application.messaging.clearMessages('trackstate');
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();

      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function() {
        self.locationChange();
      };
    });

    var track = {};
    track.tags = [];
    track.draft = true;
    track.sequential = true;
    track.lock_scorm = false;
    track.resource = false;
    track.linked_category = [];
    track.sections = [];
    track.learn_items = [];
    track.creator_bio = '';
    track.creator_notes = '';
    track.privacy_collaborators = [];
    track.allow_comments = false;
    track.allCourseIds = [];
    self.showCollaborators = false;
    self.activeTab = 'details';
    self.showSectionDeleteConfirmation = false;
    self.sectionToDelete = {}

    self.navigationDirectory = {
      'details': {
        next: 'create',
        previous: null,
        required: ['name', 'creator_name', 'creator_bio', 'description']
      },
      'create': {
        next: 'images',
        previous: 'details',
        required: null
      },
      'images': {
        next: 'categories',
        previous: 'create',
        required: null
      },
      'categories': {
        next: 'settings',
        previous: 'images',
        required: null
      },
      'settings': {
        next: null,
        previous: 'categories',
        required: null
      }
    };

    self.nextSection = function(item) {
      var nextClicked = item ? false : true;
      var item = item ? self.navigationDirectory[item].previous : self.activeTab;
      var next = self.navigationDirectory[item].next;
      var missing = '';
      var allow = true;

      var findIssues = function(check) {
        var current = self.navigationDirectory[check];
        if (current.required) {
          for (var i = 0; i < current.required.length; i++) {
            if (!self.track[current.required[i]]) {
              allow = false;
              var addField = current.required[i].replace('_', ' ').replace('creator', 'Instructor');
              missing = missing + ' ' + addField + ',';
            }
          }
        }

        if (allow && check === 'create') {
          for (var i = 0; i < self.track.sections.length; i++) {
            if (!self.track.sections[i].name) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_titleMissing'], duration: 5});
              allow = false;
              return;
            }
          }
          ;
        }

        if (current.previous) {
          findIssues(current.previous);
        }
      };

      findIssues(item);
      if (allow && next) {
        if (self.newTrack || !nextClicked) {
          if ((item === 'create' || next === 'settings') && !self.track._id && self.enableAi) {
            self.saveProgress();
          }
          self.activeTab = next;
          Application.scrollTop();
          return;
        }
        self.saveProgress('next')
            .then(function() {
              self.activeTab = next;
              Application.scrollTop();
            });
      }

      if (missing) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
      }
    };

    self.addSection = function() {
      if (!self.track.sections) {
        self.track.sections = [];
      }

      self.track.sections.push({
        name: '',
        courses: [],
        position: self.track.sections.length + 1
      });
    };

    self.noChange = function() {
      self.locationChange();
    };

    self.addImage = function(link) {
      self.track.creator_image = link;
    };

    self.removeAvatar = function() {
      self.track.creator_image = '';
    };

    self.avatarTrigger = false;
    self.uploadAvatar = function() {
      self.avatarTrigger = true;
    };

    self.saveReady = function() {
      var saveTrack = JSON.parse(JSON.stringify(self.track));
      self.missingSection = false;
      //Required due to previous population
      angular.forEach(saveTrack.sections, function(section) {
        if (!section.name) {
          self.missingSection = true;
        }
        if (section.courses.length) {
          angular.forEach(section.courses, function(course) {
            var type = course.article ? 'article' : course.file ? 'file' : course.video ? 'video' : course.quiz ? 'quiz' : course.assessment ? 'assessment' : course.scorm ? 'scorm' : null;
            if (course[type].hasOwnProperty('_id')) {
              course[type] = course[type]._id;
            }
          });
        }
      });

      if (self.missingSection) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_titleMissing'], duration: 5});
      }

      return saveTrack;
    };

    self.publishTrack = function() {
      self.track.draft = false;
      self.publishMessage = true;
      self.saveProgress()
          .then(function() {
            self.editSaved = true;
            Application.navigation.goTo('/view/tracks/' + self.track._id);
          });
    };
    
    self.onTopicChange = function(topics) {
      self.track.learn_items = topics;
    }

    self.saveProgress = function(next) {
      if (!self.track._id && self.newTrack && !next) {
        self.track.user = self.user._id;
        self.track.draft = true;
        return Tracks.create(self.track).$promise.then(function(newTrack) {
          self.updateIndicator = false;
          self.track = newTrack;
          $translate('modules.notifications.track_saved', { name: self.track.name }).then(function (
            data
          ) {
            Application.messaging.addMessage({
              type: 'success',
              text: data,
              duration: 5,
            });
          });
        }).catch(function(error) {
          self.updateIndicator = false;
          if (error.data && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
        })
      }

      let missing = ''

      for (let i = 0; i < self.navigationDirectory.details.required.length; i += 1) {
        const field = self.navigationDirectory.details.required[i]
        
        if (!self.track[field] || self.track[field] === '') {
          missing = missing + ' ' + field.replace('_', ' ').replace('creator', 'Instructor') + ',';
        }
      }

      if (missing) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
        return;
      }

      var saveTrack = self.saveReady();
      if (self.missingSection) {
        return;
      }
      self.updateIndicator = true;
      if(self.user.is_collaborator) {
        saveTrack.approval_required = true;
        saveTrack.approved = false;
      }
      return Tracks.update({
        subresource: saveTrack._id,
        fields: 'title,description,type,author,tags,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,draft,banner_image,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,resource,certificate,certificate_data,rating_configuration,allow_comments,lock_scorm'
      }, saveTrack).$promise.then(function(track) {
        Analyze.record({resource: 'modifications'}, {document: track._id, type: 'track'});
        Application.analyticsProvider.trackEvent('track_updated', {content: track._id, content_type: 'track', title: track.title});        
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.track_savedPt1'] + ' ' + self.track.name + ' ' + self.translations['modules.notifications.track_savedPt2'] + ' ' + (self.publishMessage ? 'and published to explore' : '') + (self.publishMessage ? '.' : ''), duration: 5});        
        self.updateIndicator = false;
        self.track.draft = track.draft ? true : false;
        self.publishMessage = false;
        self.editSaved = true;
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.content_issue_updating'], duration: 5});
        console.log('Error in update: ', error);
      })
    };

    self.saveMessage = function() {
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.track_savedPt1'] + ' ' + self.track.name + ' ' + self.translations['modules.notifications.track_savedPt2'] + ' ' + (self.publishMessage ? 'and published to explore' : '') + (self.publishMessage ? '.' : ''), duration: 5});
    };

    self.createTrack = function() {
      var deferred = $q.defer();

      if (!self.newTrack || self.track._id) {
        deferred.reject();
        return deferred.promise;
      }
      self.track.user = self.user._id;
      var saveTrack = self.saveReady();
      if (self.missingSection) {
        deferred.reject();
        return deferred.promise;
      }
      if(self.user.is_collaborator) {
        saveTrack.approval_required = true;
        saveTrack.approved = false;
      }
      Tracks.create(saveTrack).$promise
      .then(function(track) {
        var newUrl = $location.absUrl() + '/' + track._id;
        Application.navigation.history.push(newUrl);
        Analyze.record({resource: 'creations'}, {document: track._id, type: 'track'});
        Application.analyticsProvider.trackEvent('track_created', {content: track._id, content_type: 'track', title: track.title});
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.track_createdPt1'] + ' ' + self.track.name + ' ' + self.translations['modules.notifications.track_createdPt2'], duration: 5});
        self.track = track;
        self.newTrack = false;

        if (self.track.sections && self.track.sections.length) {
          self.track.sections.forEach(function(section) {
            if (section.courses && section.courses.length) {
              section.courses.forEach(function(course) {
                if (course.assessment) {
                  var id = course.assessment && course.assessment._id || course.assessment;
                  Assessments.update({subresource: id}, {content: {content_type: 'Track', content_name: 'track', content_id: self.track._id}});
                }
              });
            }
          });
        }
        deferred.resolve(track);
      }).catch(function(error) {
        if (error.data && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        deferred.reject();
        console.log('Error in update: ', error);
      })

      return deferred.promise;
    };

    self.goBack = function() {
      if (!self.denied || !self.backLocation) {
        Application.navigation.back();
        self.denied = true;
        return;
      }
      self.denied = true;
      var location = self.backLocation.split('/#/');
      if (location.length !== 2) {
        Application.navigation.back();
        return;
      }
      Application.navigation.goTo(location[1]);
    };

    self.modalCreate = function (publish) {
      if (self.enableAi) {
        if (publish) {
          self.track.draft = false;
          self.publishMessage = true;
          self.saveProgress().then(function () {
            self.editSaved = true;
            $translate('modules.notifications.track_published', { name: self.track.name }).then(
              function (data) {
                Application.messaging.addMessage({
                  type: 'success',
                  text: data,
                  duration: 5,
                });
              }
            );
            Application.navigation.goTo('/view/tracks/' + self.track._id);
          });
        } else {
          self.saveProgress().then(function () {
            self.editSaved = true;
            $translate('modules.notifications.track_saved', { name: self.track.name }).then(
              function (data) {
                Application.messaging.addMessage({
                  type: 'success',
                  text: data,
                  duration: 5,
                });
              }
            );
            Application.navigation.goTo('/view/tracks/' + self.track._id);
          });
        }
      } else {
        if (publish) {
          self.track.draft = false;
        }
        self.updateIndicator = true;
        self
          .createTrack()
          .then(function (track) {
            Application.messaging.addMessage({
              type: 'success',
              text:
                self.translations['modules.notifications.track_createdPt1'] +
                ' ' +
                self.track.name +
                self.translations['modules.notifications.track_createdPt2'] +
                (publish ? ' ' + self.translations['modules.notifications.track_createdPt3'] : '') +
                (publish ? '.' : ''),
              duration: 5,
            });
            self.editSaved = true;
            self.showCreateModal = false;
            self.updateIndicator = false;
            if (publish) {
              Application.navigation.goTo('/view/tracks/' + track._id);
            }
          })
          .catch(function (error) {
            self.showCreateModal = false;
            self.updateIndicator = false;
          });
      }
    };

    self.removeTrack = function() {
      if (!self.track._id) {
        return;
      }

      self.updateIndicator = true;
      self.archiveInfo = {};
      Viewables.archive({content: [{id: self.track._id, type: 'track'}]}).$promise
          .then(function(results) {
            self.archiveInfo.results = results;
            self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
            self.updateIndicator = false;
            self.showDelete = false;
            if (self.archiveInfo.show) {
              return;
            }
            self.editSaved = true;
            Analyze.record({resource: 'deletions'}, {document: self.track._id, type: 'track'});
            Application.analyticsProvider.trackEvent('track_deleted', {content: self.track._id, content_type: 'track', title: self.track.title});
            Application.navigation.goTo('/admin/content');
            Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.track_removed'], duration: 5});
          }).catch(function(err) {
        console.log('Error in update: ', err);
      })

    };

    self.sectionChange = function(section, direction) {
      var initial = section.position;
      var sign = direction === 'up' ? -1 : 1;

      for (var i = 0; i < self.track.sections.length; i++) {
        if (self.track.sections[i].position === initial + sign) {
          self.track.sections[i].position = initial;
          section.position = initial + sign;
          return;
        }
      }
    };

    self.removeSection = function(section) {
      var initial = section.position;
      var index = null;
      for (var i = 0; i < self.track.sections.length; i++) {
        if (self.track.sections[i].position === initial) {
          index = i;
        }
        if (self.track.sections[i].position > initial) {
          self.track.sections[i].position = self.track.sections[i].position - 1;
        }
      }
      ;
      self.track.sections.splice(index, 1);
    };

    self.confirmRemoveSection = function (confirmed) {
        if (confirmed) {
            self.removeSection(self.sectionToDelete);
        }
       self.showRemoveSection(false)
    }

    self.showRemoveSection = function (show, section) {
        if (show) {
            self.sectionToDelete = section
            self.showSectionDeleteConfirmation = true;
        } else {
            self.sectionToDelete = {}
            self.showSectionDeleteConfirmation = false;
        }
    }


    self.goToTrack = function() {
      self.editSaved = true;
      Application.messaging.addMessage({type: '', text: self.translations['modules.notifications.vewingUnpublishedTrack'], trackstate: true, link: '/edit/tracks/' + self.track._id});
      Application.navigation.goTo('/view/tracks/' + self.track._id);
    };

    self.resourceCheck = function() {
      if (self.track.resource && self.track.sequential) {
        self.track.sequential = false;
      }
    };

    // Check for any track additions and add them.
    var checkCondition = function() {
      var section;
      var course;
      var trackCondition = Application.trackState.get();
      if (trackCondition && trackCondition.contentId) {
        for (var i = 0; i < self.track.sections.length; i++) {
          section = self.track.sections[i];
          if (section.position !== trackCondition.section) {
            continue;
          }
          course = {
            position: trackCondition.contentPosition
          };

          course[trackCondition.contentType] = {
            _id: trackCondition.contentId,
            title: trackCondition.contentTitle
          };
          section.courses.push(course);
          self.saveProgress();
          break;
        }
      }
      if (trackCondition) {
        self.activeTab = 'create';
      }
      if (!trackCondition && self.returnState) {
        self.activeTab = 'settings';
      }
      Application.trackState.set(null);
    };

    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {survey: []},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.track.surveys;
        self.surveyAssociation.surveyIds.push(self.track.surveys[0].survey_id);
      }
    };

    self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      if (!Authorization.hasValidAuthToken()) {
        if (Application.navigation.isRouteSecure()) {
          Application.navigation.goToSignIn();
          return;
        }
      }
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }
      if (self.newTrack) {
        self.track = track;
        if (self.user.is_collaborator) {
          self.track.privacy_collaborators.push(self.user._id);
        }
        Application.trackState.set(null);
        self.addSection();
        self.startEditWatch();
        return;
      }

      AdminContent.get({
        subresource: routeParameters.id,
        fields: 'name,company,user,draft,explore_hide,description,category,topic,creator_name,creator_email,creator_bio,creator_image,creator_link,creator_notes,creator_linkedin,creator_facebook,creator_twitter,creator_slack,creator_github,creator_instagram,creator_youtube,creator_dribbble,learn_items,images,duration,quiz,sequential,tags,sections,linked_category,banner_image,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,resource,certificate,certificate_data,rating_configuration,allow_comments,lock_scorm,surveys,partner_permissions',
        'sections.courses.article-populate': 'title,duration',
        'sections.courses.video-populate': 'title,duration',
        'sections.courses.file-populate': 'title,duration',
        'sections.courses.quiz-populate': 'title,duration',
        'sections.courses.assessment-populate': 'title,duration,type,video_assessment',
        'sections.courses.scorm-populate': 'title,duration',
        types: 'tracks'
      }, async function(data) {
        if (!data || (data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.trackNotEditable'], duration: 5});
          self.editSaved = true;
          Application.navigation.goToHome();
          return;
        }
        self.track = data;
        self.track.creator_bio = self.track.creator_bio || '';
        self.track.creator_notes = typeof data.creator_notes === 'string' && data.creator_notes || '';
        if (!self.track.privacy_collaborators) {
          self.track.privacy_collaborators = [];
        }
        if (self.track.privacy_collaborators.length && !self.user.is_collaborator) {
          self.showCollaborators = true;
        }
        if (self.track.images && self.track.images.explore && !self.track.banner_image) {
          // This is required for legace tracks that have explore images but not banner images
          self.track.banner_image = self.track.images.explore;
          Application.messaging.addMessage({type: 'information', text: self.translations['edit.tracks.existing_card']});
        }
        if (!self.track.learn_items) {
          self.track.learn_items = [];
        }
        self.track.allCourseIds = [];
        for (var i = 0; i < self.track.sections.length; i++) {
          for (var j = 0; j < self.track.sections[i].courses.length; j++) {
            var course = self.track.sections[i].courses[j];
            var type = course.article ? 'article' : course.file ? 'file' : course.video ? 'video' : course.quiz ? 'quiz' : course.assessment ? 'assessment' : course.scorm ? 'scorm' : null;
            self.track.allCourseIds.push(course[type]._id);
          }
        }
        if (self.track.surveys.length) {
          self.surveyAssociation.initSurveyData();
        }
        if (self.track.partner_permissions) {
          self.partners.partnerPermission = self.track.partner_permissions;
        }
        checkCondition();
        self.startEditWatch();
      }, function(error) {
        console.log('Error occured getting track ', routeParameters.id, error);
        Application.notifications.setError(self.translations['modules.notifications.unableToGetArticle']);
      });
    };
    self.startEditWatch = function() {
      $scope.$watch('track.track', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.editSaved = false;
      }, true);

      $scope.$watch('track.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);

      $scope.$watch('track.surveyAssociation.surveyIds', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.track.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
      }, true);
      $scope.$watch('track.partners.partnerPermission', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.track.partner_permissions = newVal;
      }, true);
    };

    $translate([
      'edit.general.notification_fieldsMissing',
      'edit.general.notification_titleMissing',
      'edit.general.notification_confirmLeave',
      'modules.notifications.track_createdPt1',
      'modules.notifications.track_createdPt2',
      'modules.notifications.track_createdPt3',
      'modules.notifications.track_savedPt1',
      'modules.notifications.track_savedPt2',
      'modules.notifications.track_published',
      'modules.notifications.track_saved',
      'modules.notifications.track_removed',
      'modules.notifications.unableToGetArticle',
      'modules.notifications.vewingUnpublishedTrack',
      'modules.notifications.trackNotEditable',
      'modules.notifications.content_issue_updating',
      'edit.tracks.existing_card'
    ]).then(function(translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);
